// src/components/PushToggle.js
import React, { useEffect, useState } from "react";
import { usePushNotifications } from "customHook/usePushNotifications";
import Button from "components/Button";
import { PushNotificationsContainer } from "./styles";
import { message } from "antd";

const PushNotifications = () => {
  const {
    enabled,
    loading,
    error,
    enable,
    disable,
  } = usePushNotifications();

  const [disabled, setDisabled] = useState(false);

useEffect(() => {
  let timer;

  if(enabled) {
    setDisabled(true);
  } else {
    timer = setTimeout(() => {
      setDisabled(true);
    }, 5000);
  }

  return () => {
    if (timer) clearTimeout(timer);
  };
}, [enabled]);
  const handleEnable = async () => {
    try {
      await enable();
    } catch (err) {
      message.error(err.message);
    }
  };

  const handleDisable = async () => {
    try {
      await disable();
    } catch (err) {
      message.error(err.message);
    }
  };

  if (error) return <p>Error! {error.message}</p>;

  return (
    <PushNotificationsContainer disabled={disabled}>
      <div className="text">
        Push notifications are{" "}
        <span className="highlight">{enabled ? "ENABLED" : "DISABLED"}</span>
      </div>
      {enabled ? (
        <Button
          onClick={handleDisable}
          data-loading={loading}
          additionalstyle={`
          width:101px;
        `}
        >
          {loading ? null : "Disable Push"}
        </Button>
      ) : (
        <Button
          onClick={handleEnable}
          data-loading={loading}
          additionalstyle={`
          width:101px;
          `}
        >
          {loading ? null : "Enable Push"}
        </Button>
      )}
    </PushNotificationsContainer>
  );
};

export default PushNotifications;
